import { generateAPI } from "../api.generator";

export const getSettlementBalance = generateAPI<
  {},
  {balance: number}
>("get", "aso-ebi/settlement-balance");
